<div class="flex flex-col gap-2">
  <div>
    <h3 class="font-semibold text-[15px] leading-[19px] text-[var(--text-color)] mb-2">{{
      'graphs.multiYear.measureTitle' | transloco
    }}</h3>
    <div class="flex gap-4 flex-wrap">
      @if (selectedMeasure(); as measure) {
        <app-measure-chip
          [measure]="measure"
          (change)="addMeasure.emit()"
          (configure)="configureMeasure.emit()"
          (remove)="removeMeasure.emit()" />
      } @else {
        <button
          type="button"
          (click)="addMeasure.emit()"
          class="flex items-center gap-(--space-2) px-(--space-4) py-(--space-2) border-2 border-dashed border-[var(--border)] rounded-[var(--radius-md)] text-(color:--text-secondary) hover:border-(color:--p-primary-ui) hover:text-(--p-primary-text) transition-colors">
          <i class="pi pi-plus text-[var(--text-lg)]" aria-hidden="true"></i>
          <span>{{ 'graphs.multiYear.selectMeasure' | transloco }}</span>
        </button>
      }
    </div>
  </div>

  <div class="max-w-xl">
    <h3 class="font-semibold text-[15px] leading-[19px] text-[var(--text-color)] mb-2">{{
      'graphs.multiYear.yearsTitle' | transloco
    }}</h3>
    <div class="flex items-center gap-2 mb-2">
      <div class="flex items-center gap-2">
        <p-radioButton
          name="yearType"
          value="civile"
          [ngModel]="yearType()"
          (ngModelChange)="yearTypeChange.emit($event)"
          [disabled]="isYearTypeLocked()"
          inputId="civile" />
        <label for="civile" [class.opacity-60]="isYearTypeLocked() && yearType() !== 'civile'">{{
          'graphs.multiYear.civilYear' | transloco
        }}</label>
      </div>
      <div class="flex items-center gap-2">
        <p-radioButton
          name="yearType"
          value="hydraulique"
          [ngModel]="yearType()"
          (ngModelChange)="yearTypeChange.emit($event)"
          [disabled]="isYearTypeLocked()"
          inputId="hydraulique" />
        <label for="hydraulique" [class.opacity-60]="isYearTypeLocked() && yearType() !== 'hydraulique'">{{
          'graphs.multiYear.hydrologicalYear' | transloco
        }}</label>
      </div>
    </div>

    <div
      class="relative border border-[var(--border)] rounded bg-[var(--surface-0)] px-2 py-1 min-h-[91px] cursor-text"
      (click)="focusInput()">
      <div class="flex gap-1 flex-wrap items-center flex-1">
        @for (year of availableYears(); track year) {
          <p-chip
            [label]="year"
            [removable]="true"
            (onRemove)="removeYear.emit(year)"
            [attr.aria-label]="getYearChipAria(year)"
            styleClass="text-sm" />
        }
        <input
          #yearInputElement
          [(ngModel)]="yearInput"
          (keydown)="onKeyDown($event)"
          (keyup.enter)="onAddYear()"
          [attr.aria-label]="'graphs.multiYear.addYearsAria' | transloco"
          class="border-0 outline-none bg-transparent flex-1 min-w-[120px] p-0 text-[15px] leading-[19px] shadow-none focus:ring-0" />
      </div>

      @if (errorMessage()) {
        <div class="text-red-500 text-base absolute bottom-1 left-2" role="alert">{{ errorMessage() }}</div>
      }
    </div>
  </div>
</div>
